import { Channel } from "../Switch/SwitchStatus/SwitchStatus";

import Icon, { IconProps } from "./Icon";

const IconStatusWaiting = ({
  description, height, width, channel,
}: Omit<IconProps, "filename"> & {channel: Channel}) => <Icon filename={`${channel}-waiting.svg`} description={description} height={height} width={width} />;

export default IconStatusWaiting;
